export const ACTION_INIT_PLAYER = "ACTION_INIT_PLAYER";
export const ACTION_NEXT_TRACK = "ACTION_NEXT_TRACK";
export const ACTION_PREVIOUS_TRACK = "ACTION_PREVIOUS_TRACK";
export const ACTION_UPDATE_CHAPTERS = "ACTION_UPDATE_CHAPTERS";
